const demoVariantList = {
  moneyca: {
    color: '#8a59c9',
    imageUrl: 'https://media1.money.ca/moc-temp-logo.svg'
  },
  tenxtravel: {
    color: '#213e4a',
    imageUrl: 'https://10xtravel.com/wp-content/themes/10xTravel/images/logo.svg'
  },
  creditcards: {
    color: '#000000',
    imageUrl: 'https://www.creditcards.com/wp-content/themes/ccdc-2019/dist/images/ccLogo.svg'
  },
  savynewcanadians: {
    color: '#303030',
    imageUrl: 'https://www.savvynewcanadians.com/wp-content/uploads/2023/06/Savvy-New-Canadians_red-black_logo.svg'
  },
  flytrippers: {
    color: '#ffffff',
    imageUrl: 'https://img.flytrippers.com/wp-content/uploads/2018/10/06025803/new_logo-NOIR-SANS-FOND.png'
  },
  forbes: {
    color: '#ffffff',
    imageUrl: 'https://www.forbes.com/advisor/wp-content/uploads/2020/05/Advisor-logo_2-line_Profile-V2-e1589299562467.png'
  },
  frugalflyer: {
    color: '#ffffff',
    imageUrl: 'https://frugalflyer.ca/wp-content/uploads/2021/10/logo-frugalflyer-696x160-1.png'
  },
  lendingtree: {
    color: '#ffffff',
    imageUrl: 'https://1000logos.net/wp-content/uploads/2020/08/Lendingtree-Logo.jpg'
  },
  loanscanada: {
    color: '#ffffff',
    imageUrl: 'https://loanscanada.ca/wp-content/uploads/2020/11/logo-square-padded-1200x600-1.png'
  },
  milesopedia: {
    color: '#ffffff',
    imageUrl: 'https://milesopedia.com/wp-content/uploads/2023/01/MILESOPEDIA-logo-cmjn-black-V3@4x.png'
  },
  moneywithmark: {
    color: '#014d45',
    imageUrl: 'https://www.moneywithmark.ca/wp-content/uploads/2022/12/money-with-mark-logo-official-transparent.png'
  },
  piggybank: {
    color: '#222222',
    imageUrl: 'https://piggybank.ca/wp-content/uploads/PiggyBankLogo.png'
  },
  princeoftravel: {
    color: '#61002a',
    imageUrl: 'https://princeoftravel.com/wp-content/uploads/2020/01/footer-logo.png'
  },
  lowestrates: {
    color: '#ffffff',
    imageUrl: 'https://www.lowestrates.ca/sites/all/themes/lowestrates2019/logo.png'
  },
  wallethub: {
    color: '#14CBBC',
    imageUrl: 'https://www.insart.com/wp-content/uploads/WalletHub.png'
  },
  creditcardgenius: {
    color: '#ffffff',
    imageUrl: 'https://static.creditcardgenius.ca/7.51.0/client/assets/img/creditcardgenius-logo.svg'
  },
  moneywehave: {
    color: '#ffffff',
    imageUrl: 'https://www.moneywehave.com/wp-content/uploads/2020/05/MWH_logo_horizontal-1.webp'
  },
  sheppardandassociates: {
    color: '#ffffff',
    imageUrl: 'https://sheppardandassociates.ca/wp-content/uploads/2020/07/logo.png'
  },
  finder: {
    color: '#ffffff',
    imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/3/3c/Findercomau_logo.png?20160209051611'
  }
};
export default demoVariantList;